module.exports = __webpack_public_path__ + "static/media/logo-mdl.12f802d9.svg";